import React from 'react'
import { Stack, useMediaQuery, useTheme } from '@mui/material'
import { Box } from '@mui/system'
import { SearchableSelect, TextField } from 'src/Libs/inputs/react-hook-form'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useCountryOptions } from '@e3dc-react/shell/Hooks/useCountryOptions'

interface Props {
  isDisabled: boolean
}

const LocationForm: React.FC<Props> = ({ isDisabled }) => {
  const { t } = useCustomTranslation()
  const { allCountries } = useCountryOptions()
  const theme = useTheme()
  const isXs = useMediaQuery(theme.breakpoints.only('xs'))
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <Stack gap={3} sx={{ width: '100%' }}>
      <Stack gap={3} direction={{ xs: 'column', sm: 'row' }}>
        <Box sx={{ width: { xs: '100%', sm: '75%' } }}>
          <TextField name={'streetName'} label={t('common.street')} disabled={isDisabled} fullWidth />
        </Box>
        {isUpSm && (
          <Box sx={{ width: '25%' }}>
            <TextField name={'streetNumber'} label={t('common.streetNumber')} disabled={isDisabled} fullWidth />
          </Box>
        )}
      </Stack>

      <Stack gap={3} direction={'row'}>
        {isXs && (
          <Box sx={{ width: '50%' }}>
            <TextField name={'streetNumber'} label={t('common.streetNumber')} disabled={isDisabled} fullWidth />
          </Box>
        )}
        <Box sx={{ width: { xs: '50%', sm: '25%' } }}>
          <TextField name={'zip'} label={t('common.zip')} disabled={isDisabled} fullWidth />
        </Box>
        {isUpSm && (
          <Box sx={{ width: '75%' }}>
            <TextField name={'city'} label={t('common.city')} disabled={isDisabled} fullWidth />
          </Box>
        )}
      </Stack>
      {isXs && (
        <Box sx={{ width: '100%' }}>
          <TextField name={'city'} label={t('common.city')} disabled={isDisabled} fullWidth />
        </Box>
      )}

      <SearchableSelect name={'countryCode'} label={t('common.country')} options={allCountries} disabled={isDisabled} fullWidth />
    </Stack>
  )
}

export default LocationForm
